<template>
	<div>

		<b-row>
			<b-col>
				<div class="card bg-light mb-0">
					<div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
						<h6 class="mb-0"><font-awesome-icon icon="user" /> Account Details</h6>
					</div>
					<div class="card-body bg-white position-relative">
						<b-row align-v="center" class="loader" v-if="is_saving">
							<b-col>
								<b-spinner></b-spinner>
								<br><br>
								<strong>Loading</strong>
							</b-col>
						</b-row>
						<b-form @submit="update">
							<b-form-group
									label="Name:"
									description="This field is required"
							>
								<b-form-input
										v-model="detail_form.name"
										type="text"
										required
								></b-form-input>
							</b-form-group>
							<b-form-group
									label="Username:"
									description="This field is required"
							>
								<b-form-input
										v-model="detail_form.email"
										type="text"
										readonly
								></b-form-input>
							</b-form-group>

							<b-form-group
									label="Role:"
									description="This field is required"
							>
								<b-form-input
										v-model="detail_form.role.name"
										type="text"
										readonly
								></b-form-input>
							</b-form-group>

							<div class="text-right">
								<b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Update</b-button>
							</div>
						</b-form>
					</div>
				</div>
			</b-col>
			<b-col cols="5">
				<div class="card bg-light mb-0">
					<div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
						<h6 class="mb-0"><font-awesome-icon icon="lock" /> Change your password</h6>
					</div>
					<div class="card-body bg-white position-relative">
						<b-row align-v="center" class="loader" v-if="is_saving">
							<b-col>
								<b-spinner></b-spinner>
								<br><br>
								<strong>Loading</strong>
							</b-col>
						</b-row>
						<b-form @submit="save">
							<b-form-group
									label="Old Password:"
									description="This field is required"
							>
								<b-form-input
										v-model="form.old_password"
										type="password"
										required
								></b-form-input>
							</b-form-group>

							<b-form-group
									label="New Password:"
									description="This field is required"
							>
								<b-form-input
										v-model="form.new_password"
										type="password"
										required
								></b-form-input>
							</b-form-group>

							<div class="text-right">
								<b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Change Password</b-button>
							</div>
						</b-form>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>

    import SwalMixin from '@/views/mixins/Swal.js'
export default {
	name: 'Dashboard',
    mixins:[SwalMixin],
	data() {
		return {
            form:{
                old_password:'',
				new_password:''
			},
			detail_form:{

			},
            is_saving:false
		}
	},
    created(){
		//this.detail_form = this.$store.getters.userDetails;
		this.get();
    },
	methods: {
		get(){
			this.is_saving=true;
			this.axios.get('users/get',{params:{id:this.$store.getters.userDetails.id}}).then(response => {
				this.detail_form=response.data;
				this.is_saving=false;
			}).catch(error => console.log(error));
		},
		save(){
			event.preventDefault()
			this.swalConfirmSubmit((data)=>{
				if (data.value) {
					this.is_saving=true;
					this.axios.post('users/change-password',this.form).then(response => {
						this.is_saving=false;
						this.swalTransactionCompleted();
						this.$store.dispatch('logOutAction').then(response => {
							this.$router.push('/login')
						})
					}).catch(error => {
						this.swal_transaction_error_data.text = error.response.data;
						this.swalRequestError();
						this.is_saving=false;
					});
				}
			});
		},
		update(){
			event.preventDefault()
			this.swalConfirmSubmit((data)=>{
				if (data.value) {
					this.is_saving=true;
					this.axios.post('users/update',this.detail_form).then(response => {
						this.is_saving=false;
						this.swalTransactionCompleted();
					}).catch(error => {
						this.swal_transaction_error_data.text = error.response.data;
						this.swalRequestError();
						this.is_saving=false;
					});
				}
			});
		},
	}
}
</script>
